import { ThemeSwitch } from "@/layouts/theme-switch";
import { Button } from "@heroui/react";
import { Menu } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { UserIcon } from "@/components/icons";

const TopNav = ({ menuIcon = false, onMenuOpen }) => {
  const navigate = useNavigate();
  return (
    <header className="fixed w-full py-4 z-40 top-0 flex items-center justify-between section-padding-x">
      <button type="button" onClick={() => navigate("/")} className="flex items-center">
        <div className="rounded-full text-background">
          <img src="/logo-new.png" width={32} alt="" />
        </div>
        {/* <span className="ml-2 text-sm font-bold text-glass-foreground">Loopp</span> */}
      </button>

      <div className="flex items-center gap-2">
        <ThemeSwitch />
        {/* <Button
          type="button"
          variant="ghost"
          isIconOnly
          onPress={() => navigate("/profile")}
          className={"size-9 icon-btn"}
        >
          <UserIcon className="text-[#838383] dark:text-white size-4" />
        </Button> */}

        {menuIcon && (
          <Button isIconOnly className={"size-9 icon-button"} onPress={() => onMenuOpen()}>
            <Menu size={16} />
          </Button>
        )}
      </div>
    </header>
  );
};

export default TopNav;